import loadable from '@loadable/component';

// 懒加载组件
const ProviderManagement = loadable(() => import('./providerManagement/ProviderManagement'));
const ProviderItemManagement = loadable(() => import('./providerItemManagement/ProviderItemManagement'));
const UpstreamProviderManagement = loadable(() => import('./upstreamProviderManagement/UpstreamProviderManagement'));
const HosItemPriceWithUpstreamQuery = loadable(() => import('./hosItemPriceWithUpstreamQuery/HosItemPriceWithUpstreamQuery'));

export const subRoutes = [
  {
    path: '/ProviderManagement',
    component: ProviderManagement
  },
  {
    path: '/ProviderItemManagement',
    component: ProviderItemManagement
  },
  {
    path: '/UpstreamProviderManagement',
    component: UpstreamProviderManagement
  },
  {
    path: '/HosItemPriceWithUpstreamQuery',
    component: HosItemPriceWithUpstreamQuery
  }
];
